import axios from 'axios';

const axiosInstance = axios.create({
	//   *****baseurl*******
	 baseURL: process.env.NEXT_PUBLIC_BASE_URL,
	//  baseURL: 'https://admin.kilimanjaro-restaurants.com/api/',
	// baseURL: 'http://67.205.173.248/api/',

	headers: {
		'Content-Type': 'application/json',
	},
});
const axiosInstanceV2 = axios.create({
	
	 baseURL: process.env.NEXT_PUBLIC_BLOG_URL,
	 
	

	headers: {
		'Content-Type': 'application/json',
	},
});


export { axiosInstanceV2 };
export default axiosInstance;

// baseURL: process.env.environment === 'production'
